import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';

// Components 

import Box from '@mui/material/Box';
import Button from '../../../general/inputs/Button';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { setNotificationMessage } from '../../../../redux/features/general/notification';
import { setIsAgreementPopupOpened } from '../../../../redux/features/general/navigation';
import { updateDoctorPreferences } from '../../../../routes/doctor/patients';


interface Props { 

}; 

const Agreement: React.FC<Props> = ({ }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 
    const isMobile = useMediaQuery('(max-width: 768px)');

    const { consultationId } = useParams(); 

    const colors = useAppSelector(state => state.theme.colors); 

    const tosContent = t('tosContent', { returnObjects: true }) as any;
    const privacyContent = t('privacyContent', { returnObjects: true }) as any;


    // -- 

    const handleConsent = async () => {
        
        const updatedPreferences = { 
            isConsent: true
        }; 

        updateDoctorPreferences(updatedPreferences); 

        dispatch(setIsAgreementPopupOpened(false)); 

    }; 
    
    // -- 

    return (

        <Box 
            sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'center', 
                justifyContent: 'center',
                width: '100vw',
                height: '100vh', 
                backgroundColor: colors?.popup, 
                overflow: 'hidden', 
                position: 'absolute', 
                zIndex: 100000000,
        }}>

            <Box
                onClick={(e) => e.stopPropagation()}
                sx={{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    alignItems: 'center', 
                    textAlign: 'center', 
                    width: '100%',
                    maxWidth: isMobile ? '95vw' : '70vw', 
                    height: isMobile ? '90vh' : '85vh', 
                    padding: isMobile ? 2 : 3, 
                    borderRadius: isMobile ? 4 : 5,
                    fontSize: 14,
                    position: 'relative', 
                    backgroundColor: colors?.container,
                }}
            >

                <Box
                    sx={{ 
                        display: 'flex',
                        flexDirection: 'column', 
                        alignItems: 'center',  
                        width: '100%', 
                        height: 'calc(100% - 70px)', // Adjust height to leave space for the button
                        overflowX: 'hidden', 
                        textAlign: 'left',
                        overflowY: 'scroll',
                        padding: '0 8px',
                        scrollbarWidth: 'thin',
                        scrollbarColor: `${colors?.main} ${colors?.container}`
                    }}
                >

                    <Box
                        component="img"
                        sx={{
                            width: isMobile ? 80 : 100,
                            marginTop: 2, 
                            marginBottom: 2, 
                        }}
                        src={require('../../../../assets/icons/consultation/patientConsent.png')}
                    />

                <Box
                    sx={{ 
                        display: 'flex',
                        flexDirection: 'column', 
                        width: '90%', 
                        color: colors?.main,
                        fontWeight: 'bold', 
                        fontSize: isMobile ? 16 : 18, 
                        marginTop: 2, 
                        marginBottom: 3
                    }}
                >{t('termsOfService')}
                </Box>

                {tosContent?.map((item: any, index: number) => (
                        <Box
                            key={`tos-${index}`}
                            sx={{ 
                                display: 'flex',
                                flexDirection: 'column', 
                                width: '90%',
                                marginBottom: 2
                            }}
                        >
                            <Box
                                sx={{ 
                                    fontWeight: 'bold',
                                    fontSize: isMobile ? 13 : 14,
                                    marginBottom: 1
                                }}
                            >{item?.title}
                            </Box>
                            <Box
                                sx={{ 
                                    fontSize: isMobile ? 11 : 12,
                                }}
                            >{item?.description}
                            </Box>
                        </Box>
                ))}

                <Box
                    sx={{ 
                        display: 'flex',
                        flexDirection: 'column', 
                        width: '90%', 
                        color: colors?.main,
                        fontWeight: 'bold', 
                        fontSize: isMobile ? 16 : 18, 
                        marginTop: 2, 
                        marginBottom: 3
                    }}
                >{t('privacyPolicy')}
                </Box>

                {privacyContent?.map((item: any, index: number) => (
                        <Box
                            key={`privacy-${index}`}
                            sx={{ 
                                display: 'flex',
                                flexDirection: 'column', 
                                width: '90%',
                                marginBottom: 2
                            }}
                        >
                            <Box
                                sx={{ 
                                    fontWeight: 'bold',
                                    fontSize: isMobile ? 13 : 14,
                                    marginBottom: 1
                                }}
                            >{item?.title}
                            </Box>
                            <Box
                                sx={{ 
                                    fontSize: isMobile ? 11 : 12,
                                }}
                            >{item?.description}
                            </Box>
                        </Box>
                ))}

                <Box
                    component="img"
                    sx={{
                        width: isMobile ? 120 : 150,
                        marginTop: 4, 
                        marginBottom: 4, 
                    }}
                    src={require('../../../../assets/logos/medca_logo_blue_dark_blue.png')}
                />
                </Box>


                <Box
                    sx={{ 
                        display: 'flex', 
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: 70, 
                        bottom: 0, 
                        position: 'absolute', 
                        width: '100%', 
                        backgroundColor: colors?.container,
                        borderTop: `1px solid ${colors?.borderColor}`
                    }}
                >
                    <Button 
                        title={'agree'}
                        triggerFunction={handleConsent}
                        extraStyle={{ 
                            width: isMobile ? '80%' : 200, 
                        }}
                    />
                </Box>

            </Box>

        </Box>

  );

};

export default Agreement;